export class WidgetParam {
    CustomerId:string;
    FacilityId: string;
    StartDate: Date;
    EndDate: Date;   
    SummaryType : string;
};

export class WidgetCriteria {
    SummaryType: string;
    ProductivityInput:number;
    DesiredHourlyUnits:number;
    WaveStatusType:string;
    WaveStatusActive:string;
    ReleasedWaveLkp:string;
    PutwallLkp:string;
}

export class ForcePackwaves {
    CUSTOMER_ID: string;
    FACILITY: string;
    REPORT_DATE: Date;
    PACKWAVES_FORCE_CLOSED_COUNT: number;
};

export class ToteRecirculatingPyramid {
    CUSTOMER_ID: string;
    FACILITY: string;
    REPORT_DATE: Date;
    TOTES_RECIRCULATING_COUNT: number;
};

export class MHENoReadData {
    CUSTOMER_ID: string;
    FACILITY: string;
    YEAR_NUMBER: number;
    QUARTER_NUMBER: number;
    MONTH_ABBR_NAME: string;
    MONTH_NUMBER: number;
    WEEK_START_DATE: Date;
    WEEK_NO_IN_YEAR: number;
    REPORT_DATE: Date;
    MHE_NO_READ_COUNT: number;
};

export class BlindCountError {
    CUSTOMER_ID: string;
    FACILITY: string;
    REPORT_DATE: Date;
    BLINDS_COUNT: number;
};


// WEBPACK FOOTER //
// ./src/app/models/DataModels.ts